import { Select } from "antd";
import React from "react";

interface Props {
  className?: string;
  value?: string[];
  onChange?: (value: string[]) => void;
}

const MultiGenderSelect = ({ value, onChange, className = "" }: Props) => {
  return (
    <Select
      className={`${className}`}
      mode="multiple"
      value={value}
      onChange={onChange}
      placeholder="Select Genders"
    >
      <Select.Option value="MALE">Male</Select.Option>
      <Select.Option value="FEMALE">Female</Select.Option>
      <Select.Option value="OTHER">Other</Select.Option>
      <Select.Option value="TRANSGENDER">Transgender</Select.Option>
      <Select.Option value="NON_BINARY">Non Binary</Select.Option>
      <Select.Option value="NOT_SPECIFIED">Not Specified</Select.Option>
    </Select>
  );
};

export default MultiGenderSelect;
